<script setup lang="ts">
  import { IOrder } from '@/interfaces/IOrder';
  import { useOrdersStore } from '@/stores/orders.store';
  import { useRestaurantStore } from '@/stores/restaurant.store';
  import RestaurantPosOrdersItem from './RestaurantPosOrdersItem.vue';

  const props = defineProps<{
    orders: IOrder[];
  }>();

  const restaurantStore = useRestaurantStore();
  const ordersStore = useOrdersStore();
</script>

<template>
  <div class="pos-orders">
    <template v-if="!props.orders">
      <div class="space-y-2">
        <v-skeleton-loader v-for="i in 3" type="image" height="3rem" />
      </div>
    </template>
    <template v-else-if="!props.orders.length">
      <p class="empty">
        <v-icon>mdi-information</v-icon>
        <span>No hay pedidos</span>
      </p>
    </template>
    <template v-else>
      <div class="orders">
        <RestaurantPosOrdersItem
          v-for="order in props.orders"
          :key="order.id"
          :order="order"
        />
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss">
  .pos-orders {
    @apply tw-bg-gray-50 tw-px-2 tw-py-4 tw-rounded-lg;

    .empty {
      @apply tw-flex tw-flex-col tw-items-center tw-space-y-1 tw-text-gray-400 tw-p-4;
    }

    .orders {
      @apply tw-space-y-2.5;
    }
  }
</style>
